import { render } from "./InfiniteScroll.vue?vue&type=template&id=460778dc&ts=true"
import script from "./InfiniteScroll.vue?vue&type=script&lang=ts"
export * from "./InfiniteScroll.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__